// YERİ: src/app/domains/website/core/section-mapper.ts
// CMS'in bölüm sözleşmesi (BlockType/ContentData) ile renderer'ın beklediği
// sözleşme (sectionType/config) arasındaki köprü.
//
// İki isim var çünkü iki tablo var: platformun WebContentBlock'u ve tenant'ın
// ClientWebSection'ı. Renderer tenant tarafında doğdu; onu yeniden adlandırmak
// yerine burada tek bir yerde çeviriyoruz.

import { SiteSection } from '@/app/domains/site/core/tenant-web.service';
import { WebSection } from './web.models';

export function toSiteSection(section: WebSection): SiteSection {
  return {
    id: section.id,
    sectionType: section.blockType,
    config: section.contentData,
    displayOrder: section.displayOrder,
    isVisible: section.isVisible,
  };
}

/**
 * Ana Şablon'un bölümlerini sayfanın ÜSTÜNE ve ALTINA gelecek şekilde ayırır:
 *
 *   top    → üst menü      (sayfa içeriğinden önce)
 *   bottom → alt bilgi     (sayfa içeriğinden sonra)
 *
 * "Alt" olmanın ölçütü config.position === 'bottom' ya da tipin footer olması —
 * tenant renderer'ıyla AYNI kural. İki yerde farklı davranan bir master kavramı
 * editör için kâbus olurdu.
 *
 * Bu ayrım LAYOUT'ta kullanılır: çerçeve bir kez çizilir ve rota değişince
 * yeniden kurulmaz (menü her tıklamada yanıp sönmez). Blog ve yasal metin
 * sayfaları da — CMS sayfası olmadıkları hâlde — aynı çerçeveyi böyle kazanır.
 */
export function splitMaster(sections: WebSection[]): {
  top: SiteSection[];
  bottom: SiteSection[];
} {
  const mapped = (sections ?? []).map(toSiteSection);

  return {
    top: mapped.filter((s) => !isBottom(s)),
    bottom: mapped.filter((s) => isBottom(s)),
  };
}

function isBottom(section: SiteSection): boolean {
  if (section.sectionType === 'footer' || section.sectionType === 'mkt-footer') return true;

  try {
    const config = JSON.parse(section.config || '{}');
    return config?.position === 'bottom';
  } catch {
    return false;
  }
}
